<template>
  <div class="card">
    <h2>Duplicates list</h2>
    <p>
      Below is a list of recipients whose data may have been duplicated in our system. Click the alert button to view organization contact information for the flagged duplicate.
    </p>
    <div>
      <duplicates-table :limit="5" :allow-pagination="false" @duplicateCount="onDuplicateCount" />
      <div v-if="duplicateCount" class="col-12">
        <router-link :to="adminOrganizationURL" class="float-right link-list">
          View Full List
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import DuplicatesTable from './DuplicatesTable';
import routeNames from '../../util/routeNames';

export default {
  name: 'DuplicateList',
  components: { DuplicatesTable },
  data() {
    return {
      adminOrganizationURL: routeNames.ADMINDUPLICATES.PATH,
      duplicateCount: 0
    }
  },
  methods: {
    onDuplicateCount (duplicateCount) {
      this.duplicateCount = duplicateCount;
    }
  }
}
</script>
